import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { CentralDialogButton, BaseDialogProps } from '../../types';
import Button from '../../../../../components/Input/Button/Button';
import { useStyles } from './CentralDialog.styles';

export interface CentralDialogProps extends BaseDialogProps {
  buttons?: CentralDialogButton[];
}

const CentralDialog: React.FC<CentralDialogProps> = ({
  open,
  disableEnforceFocus = false,
  disableAutoFocus = false,
  title,
  body,
  buttons = [],
  onClose,
  dataQaId,
  children,
  className,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      disableEnforceFocus={disableEnforceFocus}
      disableAutoFocus={disableAutoFocus}
      onClose={onClose}
      classes={{
        paper: classes.paper,
      }}
      aria-labelledby="dialog-title"
      data-qa-id={`${dataQaId}-central-modal`}
      className={className}
    >
      {title && (
        <DialogTitle
          id="dialog-title"
          classes={{ root: classes.titleRoot }}
          aria-label="dialog-title"
          data-qa-id={`${dataQaId}-central-modal-title`}
        >
          {title}
        </DialogTitle>
      )}
      <DialogContent
        classes={{ root: classes.contentRoot }}
        aria-label="dialog-body"
        data-qa-id={`${dataQaId}-central-modal-body-container`}
      >
        <DialogContentText classes={{ root: classes.contentTextRoot }} data-qa-id={`${dataQaId}-central-modal-body`}>
          {body}
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        classes={{ root: classes.actionsRoot }}
        aria-label="dialog-actions"
        data-qa-id={`${dataQaId}-central-modal-buttons`}
      >
        {buttons.map((button) => (
          <Button
            {...button}
            key={button.text}
            onClick={button.onClick}
            variant={button.variant || 'contained'}
            color={button.color || 'primary'}
            size={button.size || 'small'}
            qaId={`${dataQaId}-central-modal-button-${button.text}`}
          >
            {button.text}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

export default CentralDialog;
